import { FC, useEffect, useState } from "react";
import ModalComponent from "../../shared/base-components/Modal";

import { RESPONSE_CODE } from "../../shared/models/Types";
import { errorNotify, successNotify } from "../../shared/utils/notifications";
import { Col, Collapse, Row } from "reactstrap";
import {
  CustomerMaintenanceHistoryModalProps,
  DevicePartOperation,
} from "./CustomerProfile.constants";
import AccordionCollapse from "../../shared/base-components/AccordionCollapse";
import { useCustomerAllMaintenanceMutation } from "./CustomerProfile.actions";
import { getItem } from "../../shared/hooks/useCookie";
import { useDeviceListMutation } from "../CustomerAdd/CustomerAdd.actions";

const CustomerMaintenanceHistoryModal: FC<
  CustomerMaintenanceHistoryModalProps
> = ({ isModalOpen, toggle }) => {
  const customerProfileId = getItem("customerProfileId");

  const { data, mutate } = useCustomerAllMaintenanceMutation();
  const { data: deviceListData, mutate: deviceListMutation } =
    useDeviceListMutation();

  useEffect(() => {
    mutate({ id: customerProfileId });
    deviceListMutation({});
  }, []);

  return (
    <ModalComponent
      scrollable
      header={"Geçmiş Bakımlar"}
      description={""}
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Row>
        <Col>
          <AccordionCollapse accordionList={data} />
        </Col>
      </Row>
    </ModalComponent>
  );
};

export default CustomerMaintenanceHistoryModal;
